// Third Party Imports
import React, {Component} from 'react';

// Relative Imports
import '../../utils.less';

class ListingPageAll extends Component {
    constructor(props) {
        super(props);

        this.loaded = false;
        this.state = {};
    }

    componentDidMount() {
        this.loaded = true;
    }

    componentDidUpdate() {
        /**
         * Prefetch correct ListingPage bundle first and then do re-rendering
         * Prevents screen to go blank and preserves scroll position
         * `react-async-component` isn't being used here intentionally
         */
        if (this.props.system.isMobile && !this.ListingPageMobile) {
            import('../ListingPage/ListingPageMobile')
                .then((component) => {
                    this.ListingPageMobile = component.default;
                    this.setState({mobileLoaded: true})
                })
        }
        if (this.props.system.isMobile === false && !this.ListingPageDesktop) {
            import('../ListingPage/ListingPageDesktop')
                .then((component) => {
                    this.ListingPageDesktop = component.default;
                    this.setState({desktopLoaded: true});
                });
        }
    }

    render() {
        const {
            listingPageComponent: ListingPageComponent,
            ...rest
        } = this.props;
        const {system} = rest;
        const {isMobile} = system;
        const {ListingPageMobile, ListingPageDesktop} = this;

        if (!this.loaded ||
            (isMobile && !this.state.mobileLoaded) ||
            (!isMobile && !this.state.desktopLoaded)) {
            return (<ListingPageComponent {...rest} />)
        }
        return (isMobile ? <ListingPageMobile {...rest}/> : <ListingPageDesktop {...rest}/>);
    }
}

export default ListingPageAll;
